require("!!/app/node_modules/script-loader/addScript.js")(require("!!/app/node_modules/raw-loader/index.js!/app/node_modules/xlsx/dist/xlsx.core.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/xlsx/dist/xlsx.core.min.js
// module id = 968
// module chunks = 0